import { useDispatch } from 'react-redux';
import { withFormsy } from 'formsy-react';
import { Grid, MenuItem, styled } from '@mui/material';

import { changeLanguage } from 'app/store/i18nSlice';
import useSettings from '../../hooks/useSettings';
import useUserData from '../../hooks/useUserData';
import BaseTextField, { type FieldProps } from '../components/BaseTextField';

type AppSettingsFieldProps = {
	/** The user's uid */
	userUid: string;
} & Omit<FieldProps<string>, 'startAdornment' | 'endAdornment'>;

const SelectTextField = styled(BaseTextField)(({ isEdit, theme }) => ({
	'& > .MuiInputBase-root > .MuiSelect-icon': {
		display: isEdit ? 'block' : 'none'
	}
}));

/** */
function LanguageSelectField({
	className,
	name,
	value,
	userUid,
	isEdit,
	sendChange,
	isFormSubmitted,
	isPristine,
	isValid
}: AppSettingsFieldProps) {
	const dispatch = useDispatch<any>();
	const { t } = useSettings();
	const userData = useUserData();

	const languages = [
		{
			id: 'en-US',
			title: 'English (US)',
			flag: 'us'
		},
		{
			id: 'it',
			title: 'Italiano',
			flag: 'it'
		}
	];

	const handleChange = event => {
		if (event.target.value === 'default') sendChange(name, null);
		else {
			if (userUid === userData.user_uid) dispatch(changeLanguage(event.target.value));
			sendChange(name, event.target.value);
		}
	};

	return (
		<SelectTextField
			className={className}
			name={name}
			label={t('LANGUAGE_FIELD')}
			select
			isEdit={isEdit}
			value={value || 'default'}
			isFormSubmitted={isFormSubmitted}
			isPristine={isPristine}
			isValid={isValid}
			onChange={handleChange}
		>
			<MenuItem value="default">{t('DEFAULT_VALUE')}</MenuItem>
			{languages.map(({ id, title, flag }) => (
				<MenuItem key={id} value={id}>
					<Grid container alignItems="center" spacing={2}>
						<Grid>
							<img className="min-w-20" src={`assets/images/flags/${flag}.png`} alt={flag} />
						</Grid>
						<Grid>{title}</Grid>
					</Grid>
				</MenuItem>
			))}
		</SelectTextField>
	);
}

export default withFormsy(LanguageSelectField);
